import moment from 'moment'
import 'moment-timezone'
import 'moment/dist/locale/ja'
import { v4 as uuidv4 } from 'uuid';

export const UNIXTIMESTAMP = () => {
  return moment().unix()
}

export const FORMATTEDDATE = (d, options = {}) => {
  moment.locale('ja')
  const date = options?.dayWeekLess
    ? moment.unix(d).format('M/D')
    : moment.unix(d).format('M/D dd')
  return date
}

export const FORMATBY = (d, format) => {
  moment.locale('ja')
  return moment.unix(d).format(format)
}

export const MODIFYCATEGORIES = category => {
  const colors = [
    { key: 'all', primaryColor: '#C43127' },
    { key: 'tableva', primaryColor: '#D38959' },
    { key: 'meets', primaryColor: '#D3B451' },
    { key: 'ichioshi', primaryColor: '#95B465' },
    { key: 'season', primaryColor: '#D38959' },
    { key: 'wadai', primaryColor: '#AF8779' },
    { key: 'event', primaryColor: '#83B4BC' },
    { key: 'taiken', primaryColor: '#AF8EC1' },
    { key: 'machibura', primaryColor: '#7C7470' },
  ]

  const color = colors.find(color => category.key === color.key)

  if (!color) {
    return {
      ...category,
      primaryColor: '#C43127',
    }
  }

  const { primaryColor } = color
  return {
    ...category,
    primaryColor: primaryColor ?? '#C43127',
  }
}

export const ISNEWDATE = d => {
  return moment.unix(d).isAfter(moment().subtract(7, 'd'), 'day')
}

export const GETSHOP = (shopCode, stores) => {
  const shops = stores
    .map(store => store.cities.map(citie => citie.shops?.flat())?.flat())
    ?.flat()
  return shops.find(shop => Number(shop?.shopCode) === Number(shopCode))
}

export const ADDDAY = unixTime => {
  const date = moment(unixTime * 1000)
  const hours = date.tz('Asia/Tokyo').hour()
  if (hours >= 18) {
    return parseInt(unixTime) + 86400
  } else {
    return unixTime
  }
}

export const CHECKIMPKEY = () => {
  const impressionKey = localStorage.getItem('chirashi-viewer-impression-key')
  if (impressionKey) {
    return impressionKey
  } else {
    const newKey = uuidv4()
    localStorage.setItem('chirashi-viewer-impression-key', newKey)
    const impressionKey = localStorage.getItem('chirashi-viewer-impression-key')
    return impressionKey
  }
}
